import {Card} from 'platform/components';
import {Grid, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {type OfferAlternative} from './OfferAlternative';

const t = (key: string, fallback: string) => i18n.t(key, {defaultValue: fallback});

interface AppliedAlternativeNotesProps {
  alternative: OfferAlternative;
}

/**
 * Customer notes of the applied alternative, read-only: after apply the deal terms belong to the
 * existing sale-vehicle UI and the alternative itself no longer accepts edits.
 */
export function AppliedAlternativeNotes(props: AppliedAlternativeNotesProps) {
  const {deliveryNote, customerNote} = props.alternative.terms;

  // Nothing to show is better than an empty card between the vehicle and its prices.
  if (!deliveryNote && !customerNote) {
    return null;
  }

  return (
    <Card
      variant="inlineGrey"
      title={t('entity.offerAlternative.terms.title', 'Offer terms for the customer')}
      data-testid="offerAlternativeAppliedNotes"
    >
      <Grid columns={[1, 2]}>
        <VStack spacing={1}>
          <Text size="xSmall" color="secondary">
            {t(
              'entity.offerAlternative.terms.deliveryNote',
              'Delivery information for the customer'
            )}
          </Text>
          <Text size="small">{deliveryNote ?? EMPTY_PLACEHOLDER}</Text>
        </VStack>
        <VStack spacing={1}>
          <Text size="xSmall" color="secondary">
            {t('entity.offerAlternative.terms.customerNote', 'Customer-visible note')}
          </Text>
          <Text size="small">{customerNote ?? EMPTY_PLACEHOLDER}</Text>
        </VStack>
      </Grid>
    </Card>
  );
}
